import { render } from "./PaymentDetail.vue?vue&type=template&id=7bc0f4b8"
import script from "./PaymentDetail.vue?vue&type=script&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__